import {i18n} from 'src/i18n';
import exporterFields from 'src/modules/perfilEmpleado/list/perfilEmpleadoListExporterFields';
import selectors from 'src/modules/perfilEmpleado/list/perfilEmpleadoListSelectors';
import PerfilEmpleadoService from 'src/modules/perfilEmpleado/perfilEmpleadoService';
import Errors from 'src/modules/shared/error/errors';
import Exporter from 'src/modules/shared/exporter/exporter';

const prefix = 'PERFILEMPLEADO_LIST';

const perfilEmpleadoListActions = {
  SET_ROWS: `${prefix}_SET_ROWS`,
  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,

  RESETED: `${prefix}_RESETED`,
  TOGGLE_ONE_SELECTED: `${prefix}_TOGGLE_ONE_SELECTED`,
  TOGGLE_ALL_SELECTED: `${prefix}_TOGGLE_ALL_SELECTED`,
  CLEAR_ALL_SELECTED: `${prefix}_CLEAR_ALL_SELECTED`,

  PAGINATION_CHANGED: `${prefix}_PAGINATION_CHANGED`,
  SORTER_CHANGED: `${prefix}_SORTER_CHANGED`,

  EXPORT_STARTED: `${prefix}_EXPORT_STARTED`,
  EXPORT_SUCCESS: `${prefix}_EXPORT_SUCCESS`,
  EXPORT_ERROR: `${prefix}_EXPORT_ERROR`,

  doClearAllSelected() {
    return {
      type: perfilEmpleadoListActions.CLEAR_ALL_SELECTED,
    };
  },

  doToggleAllSelected() {
    return {
      type: perfilEmpleadoListActions.TOGGLE_ALL_SELECTED,
    };
  },

  doToggleOneSelected(id) {
    return {
      type: perfilEmpleadoListActions.TOGGLE_ONE_SELECTED,
      payload: id,
    };
  },

  doReset: () => async (dispatch) => {
    dispatch({
      type: perfilEmpleadoListActions.RESETED,
    });

    dispatch(perfilEmpleadoListActions.doFetch());
  },

  doExport: () => async (dispatch, getState) => {
    try {
      if (!exporterFields || !exporterFields.length) {
        throw new Error('exporterFields is required');
      }

      dispatch({
        type: perfilEmpleadoListActions.EXPORT_STARTED,
      });

      const filter = selectors.selectFilter(getState());
      const response = await PerfilEmpleadoService.list(filter, selectors.selectOrderBy(getState()), null, null);

      new Exporter(exporterFields, i18n('entities.perfilEmpleado.exporterFileName')).transformAndExportAsExcelFile(response.rows);

      dispatch({
        type: perfilEmpleadoListActions.EXPORT_SUCCESS,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: perfilEmpleadoListActions.EXPORT_ERROR,
      });
    }
  },

  doChangePagination: (pagination) => async (dispatch, getState) => {
    dispatch({
      type: perfilEmpleadoListActions.PAGINATION_CHANGED,
      payload: pagination,
    });

    dispatch(perfilEmpleadoListActions.doFetchCurrentFilter());
  },

  doChangeSort: (sorter) => async (dispatch, getState) => {
    dispatch({
      type: perfilEmpleadoListActions.SORTER_CHANGED,
      payload: sorter,
    });

    dispatch(perfilEmpleadoListActions.doFetchCurrentFilter());
  },

  doSetRows: (rows) => async (dispatch, getState) => {
    dispatch({
      type: perfilEmpleadoListActions.SET_ROWS,
      payload: {
        rows: rows,
      },
    });
  },

  doFetchCurrentFilter: () => async (dispatch, getState) => {
    const filter = selectors.selectFilter(getState());
    const rawFilter = selectors.selectRawFilter(getState());
    dispatch(perfilEmpleadoListActions.doFetch(filter, rawFilter, true));
  },

  doFetch:
    (filter?, rawFilter?, keepPagination = false) =>
    async (dispatch, getState) => {
      try {
        dispatch({
          type: perfilEmpleadoListActions.FETCH_STARTED,
          payload: {filter, rawFilter, keepPagination},
        });

        const response = await PerfilEmpleadoService.list(
          filter,
          selectors.selectOrderBy(getState()),
          selectors.selectLimit(getState()),
          selectors.selectOffset(getState()),
        );

        dispatch({
          type: perfilEmpleadoListActions.FETCH_SUCCESS,
          payload: {
            rows: response.rows,
            count: response.count,
            emailsFilterStats: response.emailsFilterStats ?? null,
          },
        });
      } catch (error) {
        Errors.handle(error);

        dispatch({
          type: perfilEmpleadoListActions.FETCH_ERROR,
        });
      }
    },
};

export default perfilEmpleadoListActions;
